<div class="flex flex-col lg:flex-row w-full min-h-screen bg-[#232323] text-white">
  
  <!-- Área Principal do Player -->
  <div class="flex-1 flex flex-col">
    <!-- Header da Aula -->
    <header class="px-6 md:px-10 pt-8 pb-4">
      <div class="flex items-start gap-4">
        <button mat-icon-button (click)="voltarParaModulo()" 
                class="!bg-zinc-800 hover:!bg-zinc-700 !text-white -ml-2 mt-1"
                matTooltip="Voltar para o módulo">
          <mat-icon svgIcon="heroicons_outline:arrow-left" class="icon-size-5"></mat-icon>
        </button>
        <div class="flex-1">
          <div class="flex items-center gap-3 mb-2">
            <span class="text-xs font-semibold uppercase tracking-wider text-[#E4811E] bg-[#E4811E]/10 px-3 py-1 rounded-full">
              {{ modulo?.nome }}
            </span>
            <span class="text-xs text-white/50">Aula {{ aula?.ordemAula }}</span>
          </div>
          <h1 class="text-2xl md:text-3xl font-bold text-white leading-tight">{{ aula?.titulo }}</h1>
          <p *ngIf="aula?.descricao" class="mt-2 text-white/60 text-sm md:text-base max-w-3xl">{{ aula?.descricao }}</p>
        </div>
      </div>
    </header>

    <!-- Player de Vídeo -->
    <div class="px-6 md:px-10 pb-6">
      <div class="relative aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl shadow-black/50 ring-1 ring-white/10">
        <iframe 
          #pandaIframe 
          *ngIf="aula?.videoUrl" 
          [src]="aula.videoUrl | safeUrl" 
          class="w-full h-full"
          allow="accelerometer; gyroscope; autoplay; encrypted-media" 
          allowfullscreen>
        </iframe>
        
        <!-- Overlay de Loading do Player -->
        <div *ngIf="!aula?.videoUrl" class="absolute inset-0 flex items-center justify-center bg-zinc-900">
          <div class="flex flex-col items-center gap-3">
            <mat-spinner diameter="40"></mat-spinner>
            <span class="text-white/50 text-sm">Carregando vídeo...</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Material de Apoio -->
    <div *ngIf="aula?.materialApoio" class="px-6 md:px-10 pb-8">
      <div class="bg-zinc-800/50 border border-zinc-700 rounded-xl p-4 flex items-center gap-4 hover:bg-zinc-800 transition-colors">
        <div class="w-12 h-12 rounded-lg bg-red-500/10 flex items-center justify-center flex-shrink-0">
          <mat-icon svgIcon="heroicons_outline:document-text" class="text-red-400 icon-size-6"></mat-icon>
        </div>
        <div class="flex-1 min-w-0">
          <p class="font-semibold text-white truncate">{{ aula.materialApoio.nome }}</p>
          <p class="text-xs text-white/50">Material de apoio do módulo • PDF</p>
        </div>
        <a [href]="aula.materialApoio.url" target="_blank"
           class="flex items-center gap-2 bg-[#E4811E] hover:bg-[#d4751a] text-white px-4 py-2 rounded-lg font-medium text-sm transition-colors flex-shrink-0">
          <mat-icon svgIcon="heroicons_outline:arrow-down-tray" class="icon-size-4"></mat-icon>
          Baixar
        </a>
      </div>
    </div>
  </div>

  <!-- Sidebar - Conteúdo do Curso -->
  <aside class="w-full lg:w-96 xl:w-[420px] bg-zinc-900 border-l border-zinc-800 flex flex-col max-h-screen lg:sticky lg:top-0">
    <!-- Header da Sidebar -->
    <div class="px-5 py-5 border-b border-zinc-800 flex-shrink-0">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-lg bg-[#E4811E]/10 flex items-center justify-center">
          <mat-icon svgIcon="heroicons_outline:academic-cap" class="text-[#E4811E] icon-size-5"></mat-icon>
        </div>
        <div>
          <h2 class="font-bold text-white">Conteúdo do Curso</h2>
          <p class="text-xs text-white/50">{{ getTotalAulas() }} aulas nesta trilha</p>
        </div>
      </div>
    </div>

    <!-- Lista de Módulos -->
    <div class="flex-1 overflow-y-auto custom-scrollbar">
      <!-- Loading -->
      <ng-container *ngIf="carregando">
        <div class="p-5 space-y-4">
          <div *ngFor="let _ of [0,1,2]" class="animate-pulse">
            <div class="h-4 w-40 bg-white/10 rounded mb-3"></div>
            <div class="space-y-2 ml-5">
              <div class="h-3 w-56 bg-white/10 rounded"></div>
              <div class="h-3 w-48 bg-white/10 rounded"></div>
              <div class="h-3 w-52 bg-white/10 rounded"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Conteúdo -->
      <ng-container *ngIf="!carregando">
        <div class="py-3">
          <div *ngFor="let moduloItem of modulosDaTrilha; trackBy: trackByModulo; let moduloIdx = index" 
               class="border-b border-zinc-800/50 last:border-0">
            
            <!-- Header do Módulo -->
            <button (click)="toggleModulo(moduloItem)" 
                    class="w-full px-5 py-4 flex items-center gap-3 text-left hover:bg-zinc-800/50 transition-colors"
                    [attr.aria-expanded]="isExpanded(moduloItem)">
              
              <!-- Indicador de Status do Módulo -->
              <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-bold transition-all"
                   [ngClass]="{
                     'bg-[#E4811E] text-white': isModuloAtual(moduloItem),
                     'bg-green-500 text-white': moduloItem.concluidoLocal && !isModuloAtual(moduloItem),
                     'bg-zinc-700 text-white/70': !moduloItem.concluidoLocal && !isModuloAtual(moduloItem)
                   }">
                <mat-icon *ngIf="moduloItem.concluidoLocal && !isModuloAtual(moduloItem)" 
                          svgIcon="heroicons_mini:check" class="icon-size-4"></mat-icon>
                <span *ngIf="!moduloItem.concluidoLocal || isModuloAtual(moduloItem)">{{ moduloIdx + 1 }}</span>
              </div>

              <div class="flex-1 min-w-0">
                <h3 class="font-semibold text-sm truncate transition-colors"
                    [ngClass]="{
                      'text-[#E4811E]': isModuloAtual(moduloItem),
                      'text-white': !isModuloAtual(moduloItem)
                    }">
                  {{ moduloItem.nome }}
                </h3>
                <p class="text-xs text-white/50 mt-0.5">
                  {{ moduloItem.quantidadeAulas }} {{ moduloItem.quantidadeAulas === 1 ? 'aula' : 'aulas' }}
                  <span *ngIf="moduloItem.concluidoLocal" class="text-green-400 ml-2">• Concluído</span>
                </p>
              </div>

              <!-- Chevron -->
              <mat-icon class="icon-size-5 text-white/40 transition-transform duration-200"
                        [ngClass]="{'rotate-180': isExpanded(moduloItem)}"
                        svgIcon="heroicons_mini:chevron-down"></mat-icon>
            </button>

            <!-- Lista de Aulas do Módulo -->
            <div *ngIf="isExpanded(moduloItem)" class="pb-3 px-3">
              <ul class="space-y-1">
                <li *ngFor="let aulaItem of moduloItem.aulas; trackBy: trackByAula">
                  <button (click)="navegarParaAula(aulaItem)"
                          class="w-full text-left flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all"
                          [ngClass]="{
                            'bg-[#E4811E]/15 border border-[#E4811E]/30': aulaItem.id === aula.id,
                            'hover:bg-zinc-800': aulaItem.id !== aula.id
                          }">
                    
                    <!-- Status da Aula -->
                    <div class="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 text-[10px] font-semibold"
                         [ngClass]="{
                           'bg-[#E4811E] text-white': aulaItem.id === aula.id,
                           'bg-green-500/20 text-green-400': aulaItem.concluida && aulaItem.id !== aula.id,
                           'bg-zinc-700 text-white/50': !aulaItem.concluida && aulaItem.id !== aula.id
                         }">
                      <mat-icon *ngIf="aulaItem.concluida && aulaItem.id !== aula.id" 
                                svgIcon="heroicons_mini:check" class="icon-size-3"></mat-icon>
                      <mat-icon *ngIf="aulaItem.id === aula.id" 
                                svgIcon="heroicons_mini:play" class="icon-size-3"></mat-icon>
                      <span *ngIf="!aulaItem.concluida && aulaItem.id !== aula.id">{{ aulaItem.ordemAula }}</span>
                    </div>

                    <!-- Info da Aula -->
                    <div class="flex-1 min-w-0">
                      <p class="text-sm truncate transition-colors"
                         [ngClass]="{
                           'text-[#E4811E] font-semibold': aulaItem.id === aula.id,
                           'text-white': aulaItem.id !== aula.id
                         }">
                        {{ aulaItem.titulo }}
                      </p>
                    </div>

                    <!-- Badge Concluída -->
                    <span *ngIf="aulaItem.concluida && aulaItem.id !== aula.id" 
                          class="text-[10px] text-green-400 font-medium flex-shrink-0">
                      ✓
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </aside>

  <!-- Botão Flutuante de Anotações -->
  <button (click)="exibirAnotacoes = !exibirAnotacoes"
          class="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-gradient-to-r from-[#E4811E] to-[#d4751a] hover:from-[#d4751a] hover:to-[#c46815] text-white px-5 py-3 rounded-full shadow-lg shadow-[#E4811E]/25 transition-all duration-300 hover:scale-105"
          [ngClass]="{'ring-2 ring-white/30': exibirAnotacoes}">
    <mat-icon svgIcon="heroicons_outline:pencil-square" class="icon-size-5"></mat-icon>
    <span class="font-semibold text-sm">Anotações</span>
    <span *ngIf="anotacoes.length > 0" 
          class="ml-1 w-5 h-5 rounded-full bg-white/20 flex items-center justify-center text-xs font-bold">
      {{ anotacoes.length }}
    </span>
  </button>

  <!-- Painel de Anotações -->
  <div *ngIf="exibirAnotacoes" 
       class="fixed bottom-24 right-6 w-96 max-w-[calc(100vw-3rem)] bg-zinc-900 rounded-2xl shadow-2xl border border-zinc-700 z-50 overflow-hidden"
       style="max-height: calc(100vh - 200px);">
    
    <!-- Header do Painel -->
    <div class="px-5 py-4 bg-zinc-800/50 border-b border-zinc-700 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-[#E4811E]/10 flex items-center justify-center">
          <mat-icon svgIcon="heroicons_outline:pencil-square" class="text-[#E4811E] icon-size-5"></mat-icon>
        </div>
        <div>
          <h2 class="font-bold text-white text-sm">Minhas Anotações</h2>
          <p class="text-xs text-white/50">{{ anotacoes.length }} anotação(ões) nesta aula</p>
        </div>
      </div>
      <button (click)="exibirAnotacoes = false" 
              class="w-8 h-8 rounded-lg hover:bg-zinc-700 flex items-center justify-center transition-colors">
        <mat-icon svgIcon="heroicons_outline:x-mark" class="text-white/60 icon-size-5"></mat-icon>
      </button>
    </div>

    <!-- Lista de Anotações -->
    <div class="p-4 max-h-60 overflow-y-auto custom-scrollbar space-y-3">
      <ng-container *ngIf="anotacoes.length; else semNotas">
        <div *ngFor="let nota of anotacoes" 
             class="bg-zinc-800 rounded-xl p-4 border border-zinc-700 transition-all hover:border-zinc-600">
          
          <!-- Modo Visualização -->
          <div *ngIf="editandoId !== nota.id">
            <p class="text-sm text-white/90 whitespace-pre-wrap break-words leading-relaxed">{{ nota.texto }}</p>
            <div class="flex items-center justify-end gap-2 mt-3 pt-3 border-t border-zinc-700/50">
              <button (click)="iniciarEdicao(nota)"
                      class="flex items-center gap-1.5 text-xs text-white/50 hover:text-[#E4811E] px-2 py-1 rounded-md hover:bg-zinc-700/50 transition-all">
                <mat-icon svgIcon="heroicons_outline:pencil" class="icon-size-3.5"></mat-icon>
                Editar
              </button>
              <button (click)="excluirAnotacao(nota.id)"
                      class="flex items-center gap-1.5 text-xs text-white/50 hover:text-red-400 px-2 py-1 rounded-md hover:bg-red-500/10 transition-all">
                <mat-icon svgIcon="heroicons_outline:trash" class="icon-size-3.5"></mat-icon>
                Excluir
              </button>
            </div>
          </div>

          <!-- Modo Edição -->
          <div *ngIf="editandoId === nota.id" class="space-y-3">
            <textarea [formControl]="editForm.controls['texto']"
                      class="w-full resize-none bg-zinc-700 border border-zinc-600 rounded-lg p-3 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-[#E4811E] focus:ring-1 focus:ring-[#E4811E] transition-all"
                      rows="3"
                      placeholder="Edite sua anotação..."></textarea>
            <div class="flex items-center justify-end gap-2">
              <button (click)="cancelarEdicao()"
                      class="px-3 py-1.5 text-xs text-white/60 hover:text-white bg-zinc-700 hover:bg-zinc-600 rounded-lg transition-colors">
                Cancelar
              </button>
              <button (click)="salvarEdicao()" 
                      [disabled]="editForm.invalid"
                      class="px-3 py-1.5 text-xs font-medium text-white bg-[#E4811E] hover:bg-[#d4751a] rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                Salvar
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #semNotas>
        <div class="text-center py-6">
          <div class="w-12 h-12 rounded-full bg-zinc-800 flex items-center justify-center mx-auto mb-3">
            <mat-icon svgIcon="heroicons_outline:document-text" class="text-white/30 icon-size-6"></mat-icon>
          </div>
          <p class="text-sm text-white/40">Nenhuma anotação ainda</p>
          <p class="text-xs text-white/30 mt-1">Comece a fazer anotações sobre esta aula</p>
        </div>
      </ng-template>
    </div>

    <!-- Formulário de Nova Anotação -->
    <div class="p-4 border-t border-zinc-700 bg-zinc-800/30">
      <form [formGroup]="anotacaoForm" (ngSubmit)="adicionarAnotacao()" class="space-y-3">
        <textarea formControlName="texto" 
                  placeholder="Escreva uma nova anotação..."
                  class="w-full resize-none bg-zinc-800 border border-zinc-700 rounded-lg p-3 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-[#E4811E] focus:ring-1 focus:ring-[#E4811E] transition-all"
                  rows="3"></textarea>
        <div class="flex items-center justify-between">
          <span class="text-xs text-white/40">
            {{ anotacaoForm.value.texto?.length || 0 }}/300 caracteres
          </span>
          <button type="submit" 
                  [disabled]="anotacaoForm.invalid"
                  class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[#E4811E] hover:bg-[#d4751a] rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            <mat-icon svgIcon="heroicons_outline:plus" class="icon-size-4"></mat-icon>
            Adicionar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Toast de Auto-Avanço -->
  <div *ngIf="nextToastVisible"
       class="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-zinc-800 text-white rounded-xl shadow-2xl border border-zinc-700 px-5 py-4 flex items-center gap-4">
    <div class="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center">
      <mat-icon svgIcon="heroicons_outline:play" class="text-green-400 icon-size-5"></mat-icon>
    </div>
    <div>
      <p class="text-sm font-medium text-white">Próxima aula em <span class="text-[#E4811E] font-bold">{{ nextToastSeconds }}s</span></p>
      <p class="text-xs text-white/50 mt-0.5">Aula concluída com sucesso!</p>
    </div>
    <button (click)="cancelNextToast()" 
            class="ml-2 px-4 py-2 text-xs font-medium text-white/70 hover:text-white bg-zinc-700 hover:bg-zinc-600 rounded-lg transition-colors">
      Cancelar
    </button>
  </div>
</div>